/**
 * In-app legal documents. The PDFs are the same files the marketing site
 * publishes (`landing_page/src/assets/`), served statically from
 * `frontend/public/legal/` so nginx returns them without the SPA fallback.
 * The routes render them in a viewer page and are reachable without a
 * session: the cookie banner links here before anyone signs in.
 */
export const PRIVACY_POLICY_PATH = '/privacy-policy';
export const TERMS_OF_USE_PATH = '/terms-of-use';

export const PRIVACY_POLICY_PDF = '/legal/specificAI_privacy_policy.pdf';
export const TERMS_OF_USE_PDF = '/legal/specificAI_terms_of_use.pdf';

export const LEGAL_DOCUMENTS = Object.freeze({
    privacyPolicy: Object.freeze({ title: 'Privacy Policy', path: PRIVACY_POLICY_PATH, pdf: PRIVACY_POLICY_PDF }),
    termsOfUse: Object.freeze({ title: 'Terms of Use', path: TERMS_OF_USE_PATH, pdf: TERMS_OF_USE_PDF }),
});
